import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
/*
  Play/Pause Toggle Button

  Controls whether the media player's media is playing or paused.
*/
export default class PlayPauseToggleButton extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.store = props.ControlsStore;
    this.ControlsActions = this.store.ControlsActions;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.isPause != this.state.isPause;
  }
  render() {
    const buttonClass = cx({
      'play': this.state.isPause,
      'pause': !this.state.isPause
    })
    const buttonProps = {
      className: buttonClass,
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.ControlsActions.togglePlayPause();
      }
    }
    return (
      <div className="playpause">
        <button {...buttonProps}></button>
      </div>
    );
  }
}

PlayPauseToggleButton.propTypes = {
  ControlsStore: React.PropTypes.object.isRequired
};
PlayPauseToggleButton.defaultProps = {};



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/play-pause-toggle-button.jsx